import React, { useEffect } from 'react';
import { TimelineItem } from '../timeline/types';
import { MdLocationOff } from "react-icons/md";

interface TimelineCardProps {
    item: TimelineItem;
    className?: string;
    isSelected: boolean;
    onClick: (item: TimelineItem) => void;
    onHoverChange: (isHovered: boolean) => void;
    shouldFlash?: boolean;
    onEndFlash?: () => void;
}

const TimelineCard: React.FC<TimelineCardProps> = ({
    item,
    className = '',
    isSelected,
    onClick,
    onHoverChange,
    shouldFlash = false,
    onEndFlash
}) => {
    const noLocation = (item.lat === null || item.lng === null);

    const containerClasses = `
        max-w-[350px] 
        w-full 
        p-3
        ${className}
        rounded
        transition-all 
        duration-200 
        ease-in-out
        ${noLocation
            ? 'cursor-default'
            : 'cursor-pointer'
        }
        ${noLocation
            ? ''
            : isSelected
                ? 'bg-gray-100 shadow-md'
                : 'hover:bg-gray-100 hover:shadow-md'
        }
        ${shouldFlash ? 'flash flash-gray' : ''} 
    `;

    useEffect(() => {
        if (shouldFlash && onEndFlash) {
            const animationDuration = 3000;
            const timer = setTimeout(() => {
                onEndFlash();
            }, animationDuration);

            return () => clearTimeout(timer);
        }
    }, [shouldFlash, onEndFlash]);

    return (
        <div
            id={`event-${item.publicId}`}
            className={containerClasses}
            onMouseEnter={() => !noLocation && onHoverChange(true)}
            onMouseLeave={() => !noLocation && onHoverChange(false)}
        >
            <div className="h-full rounded max-h-[200px] overflow-hidden">
                <div onClick={() => !noLocation && onClick(item)} className="h-full">
                    <div className="flex flex-col h-full">
                        <div className="text-left flex-grow">
                            <h3 className="text-lg font-semibold text-ellipsis overflow-hidden whitespace-nowrap">
                                {item.title}
                            </h3>
                            {noLocation && (
                                <p className="flex items-center text-sm text-gray-500 mt-1">
                                    <MdLocationOff size={20} className="mr-1" />
                                    No Event Location Data
                                </p>
                            )}

                            {item.description && (
                                <div className="mt-1 relative">
                                    <p className="text-gray-700 break-words line-clamp-4">
                                        {item.description}
                                    </p>
                                </div>
                            )}

                            <span className="block mt-2 text-sm text-gray-500">
                                {item.date}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TimelineCard;
